/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon20Light = forwardRef('MathDeltaIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7 17c1.502 0 2.468-1.594 1.774-2.925L11.773 3.149c-.748-1.434-2.799-1.434-3.546 0L2.526 14.075C1.83 15.406 2.797 17 4.299 17H15.7Zm-.991-1a1 1 0 0 0 .886-1.463L10.397 4.58a1 1 0 0 0-1.773 0l-5.198 9.958A1 1 0 0 0 4.312 16H14.71Z" })));
});
